import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Grid, Toolbar, Typography, Tooltip, IconButton } from '@material-ui/core';
import { Power as PowerIcon } from '@mummssoftware/icons';
import SitePicker from '../SitePicker';
import AgencyPicker from '../AgencyPicker';
import messages from './messages';
const Root = styled.div.withConfig({
  displayName: "TopBar__Root",
  componentId: "sc-1dqz2lj-0"
})(["flex-grow:1;@media print{display:none;}"]);
const RightItems = styled(Grid).withConfig({
  displayName: "TopBar__RightItems",
  componentId: "sc-1dqz2lj-1"
})(["&&{width:auto;margin:0.25rem 0;justify-content:flex-end;flex-grow:1;}"]);
const SubItems = styled(Grid).withConfig({
  displayName: "TopBar__SubItems",
  componentId: "sc-1dqz2lj-2"
})(["&&{width:auto;margin:-0.25rem 0;}"]);
const NameSpan = styled.span.withConfig({
  displayName: "TopBar__NameSpan",
  componentId: "sc-1dqz2lj-3"
})(["white-space:pre;"]);
const withStyles = makeStyles(theme => {
  const mobileTitles = {
    [theme.breakpoints.only('xs')]: {
      fontSize: 14,
      fontWeight: 200
    }
  };
  return {
    appBar: {
      background: theme.props.header.background,
      boxShadow: 'none'
    },
    appBarFixed: {
      marginTop: 'var(--safe-area-inset-top)'
    },
    toolBarRoot: {
      flexGrow: 1,
      flexWrap: 'wrap',
      minHeight: theme.props.header.headerHeight
    },
    toolBarGutters: {
      paddingLeft: 17.5,
      paddingRight: 17.5,
      [theme.breakpoints.only('xs')]: {
        paddingLeft: 5.5
      }
    },
    agencyRoot: {// placeholder for root agency picker styles
    },
    grow: {
      flexGrow: 1
    },
    logOutRoot: {
      padding: 4,
      minHeight: 34
    },
    leftTitle: _objectSpread(_objectSpread({
      width: 'fit-content',
      paddingRight: 17.5
    }, theme.props.header.leftTitle), mobileTitles),
    rightTitle: _objectSpread(_objectSpread({
      minWidth: 'min-content',
      maxWidth: 'fit-content',
      flexBasis: 0,
      flexGrow: 1,
      textAlign: 'right',
      margin: '-.25rem 0',
      paddingRight: 5,
      // Ensures name doesn't break to 3 lines
      '&:before': {
        width: '8ch',
        content: '""',
        fontSize: 'initial',
        display: 'block',
        overflow: 'hidden'
      }
    }, theme.props.header.rightTitle), mobileTitles)
  };
});

var _ref = /*#__PURE__*/React.createElement(PowerIcon, null);

export const TopBar = /*#__PURE__*/forwardRef((props, ref) => {
  const classes = withStyles();
  const {
    formatMessage
  } = useIntl();
  let firstName;
  let lastName;
  let currentAgency;
  let agencyList;
  let siteList;
  let currentSite;

  if ('currentUser' in props && typeof props.currentUser !== 'undefined') {
    const {
      currentUser,
      currentUser: {
        currentHospiceBin: hospiceBin,
        hospiceName,
        siteId,
        siteNickname
      }
    } = props;
    ({
      firstName,
      lastName,
      siteList
    } = currentUser);
    /* eslint-disable indent */

    currentAgency = hospiceName ? {
      hospiceBin,
      hospiceName
    } : undefined;
    /* eslint-enable */

    currentSite = {
      id: siteId,
      nickName: siteNickname
    };
  } else {
    ({
      firstName,
      lastName,
      siteList,
      currentAgency,
      agencyList,
      currentSite
    } = props);
  }

  const {
    action,
    disableSitePicker,
    leftAction,
    subtitle,
    title,
    titleInfo = '',
    position,
    enableAgencyPicker,
    onAgencyChange,
    onSiteChange,
    logout,
    noLogout
  } = props;
  const appBarPosition = position || 'fixed';
  const [titleOpen, setTitleOpen] = useState(false);

  function handleTitleTooltipClose() {
    setTitleOpen(false);
  }

  function handleTitleTooltipOpen(e) {
    if (e.altKey) {
      setTitleOpen(true);
    }
  }

  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(AppBar, {
    ref: ref,
    "data-testid": "MUI-appBar",
    className: classes.appBar,
    classes: {
      positionFixed: classes.appBarFixed
    },
    position: appBarPosition,
    color: "secondary"
  }, /*#__PURE__*/React.createElement(Toolbar, {
    classes: {
      root: classes.toolBarRoot,
      gutters: classes.toolBarGutters
    },
    variant: "dense"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottom-start",
    title: titleInfo,
    "aria-label": "about",
    open: titleOpen,
    onClose: handleTitleTooltipClose
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.grow,
    onClick: handleTitleTooltipOpen,
    variant: "h6",
    color: "textPrimary",
    classes: {
      h6: classes.leftTitle
    }
  }, title, subtitle ? /*#__PURE__*/React.createElement(Typography, {
    className: classes.grow,
    onClick: handleTitleTooltipOpen,
    variant: "h6",
    component: "span",
    color: "textPrimary",
    classes: {
      h6: classes.leftTitle
    }
  }, ': ', subtitle) : null)), !noLogout && /*#__PURE__*/React.createElement(RightItems, {
    container: true,
    item: true,
    alignItems: "center",
    xs: "auto"
  }, leftAction && leftAction, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    classes: {
      h6: classes.rightTitle
    },
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("span", null, firstName, " "), /*#__PURE__*/React.createElement(NameSpan, null, lastName, " @")), /*#__PURE__*/React.createElement(SubItems, {
    container: true,
    item: true,
    alignItems: "center",
    wrap: "nowrap",
    xs: "auto"
  }, /*#__PURE__*/React.createElement(AgencyPicker, {
    className: classes.agencyRoot,
    agencyList: agencyList,
    currentAgency: currentAgency,
    disabled: !enableAgencyPicker,
    onAgencyChange: onAgencyChange
  }), !enableAgencyPicker && currentAgency ? /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    style: {
      whiteSpace: 'pre'
    }
  }, ' ', "-") : null, /*#__PURE__*/React.createElement(SitePicker, {
    siteList: siteList,
    currentSite: currentSite,
    onSiteChange: onSiteChange,
    disabled: disableSitePicker
  }), action && action, /*#__PURE__*/React.createElement(Tooltip, {
    title: formatMessage(messages.logout),
    "aria-label": "Logout"
  }, /*#__PURE__*/React.createElement(IconButton, {
    classes: {
      root: classes.logOutRoot
    },
    color: "primary",
    "aria-label": "Menu",
    onClick: logout
  }, _ref)))))));
});
export default TopBar;